"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Values are use in multi-quote. May need to redeploy multi-quote if the values
// are changed.

var age = exports.age = {
  min: 17,
  max: 27
};
var vehicleValue = exports.vehicleValue = {
  min: 1,
  max: 30000
};